import { render, staticRenderFns } from "./control-rely.vue?vue&type=template&id=12476ce0"
import script from "./control-rely.vue?vue&type=script&lang=js"
export * from "./control-rely.vue?vue&type=script&lang=js"
import style0 from "./control-rely.vue?vue&type=style&index=0&id=12476ce0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports